import { ICredential, ICredentialForm } from '@givebacks/api/core';
import { atom } from 'jotai';

/**
 *  Prior to a credit card being validated, this is the pending credential form
 */
const credentialFormAtom = atom<ICredentialForm | undefined>(undefined);
credentialFormAtom.debugLabel = 'checkout_cartCredentialForm';

/**
 * This is used for when the user is choosing to use an existing credential during donation checkout
 */
const existingCredentialAtom = atom<ICredential | undefined>(undefined);
existingCredentialAtom.debugLabel = 'checkout_ExistingCredential';

export { credentialFormAtom, existingCredentialAtom };
